module.exports = __webpack_public_path__ + "static/media/m256.50ad484d.webp";